import { render } from "./keyAreaMonitor.vue?vue&type=template&id=ac02c03e&scoped=true"
import script from "./keyAreaMonitor.vue?vue&type=script&lang=js"
export * from "./keyAreaMonitor.vue?vue&type=script&lang=js"

import "./keyAreaMonitor.vue?vue&type=style&index=0&id=ac02c03e&lang=scss"
import "./keyAreaMonitor.vue?vue&type=style&index=1&id=ac02c03e&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac02c03e"]])

export default __exports__